module.exports = __webpack_public_path__ + "assets/img/driver-btn-8abe24b8.png";